
import React, { useState, useEffect } from "react";
import "./Sidebar.css";
import {
  FiClock,
  FiGrid,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";

function escapeHTML(str) {
  if (typeof str !== 'string') return str;
  return str.replace(/[&<>'"]/g, function (tag) {
    const charsToReplace = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    };
    return charsToReplace[tag] || tag;
  });
}

function Sidebar({ activeDashboard, setActiveDashboard, onQuerySelect, clearChatTrigger, user }) {
  const [isExpanded, setIsExpanded] = useState(true);

  const dashboards = ["Firm and Opportunity", "Order Book"];
  const [recentQueries, setRecentQueries] = useState([]);

  // Load recent queries from localStorage/session per user+dashboard
  useEffect(() => {
    if (!user) return;
    const key = `recentQueries_${user.id}_${activeDashboard}`;
    const stored = localStorage.getItem(key);
    let queries = [];
    try {
      queries = stored ? JSON.parse(stored) : [];
      // Sanitize all loaded queries
      queries = queries.map(q => escapeHTML(q));
    } catch (e) {
      queries = [];
    }
    setRecentQueries(queries);
  }, [user, activeDashboard]);

  useEffect(() => {
    setRecentQueries([]);
  }, [clearChatTrigger]);

  // Listen for new queries added from ChatBox
  useEffect(() => {
    const handler = (e) => {
      if (e.detail && e.detail.dashboard === activeDashboard && e.detail.userId === user?.id) {
        setRecentQueries((prev) => {
          // Sanitize before storing
          const safeQuery = escapeHTML(e.detail.query);
          const updated = [safeQuery, ...prev.filter(q => q !== safeQuery)].slice(0, 10);
          localStorage.setItem(`recentQueries_${user.id}_${activeDashboard}`, JSON.stringify(updated));
          return updated;
        });
      }
    };
    window.addEventListener("newQuery", handler);
    return () => window.removeEventListener("newQuery", handler);
  }, [activeDashboard, user]);

  return (
 

    <div className={`sidebar ${isExpanded ? "expanded" : "collapsed"}`}>
      {/* Header */}
      <div className="sidebar-header-container">
        <div className="list-icon">
          <FiGrid size={18} />
          {isExpanded && <div className="sidebar-header">Dashboards</div>}
        </div>

        <div
          className="sidebar-toggle"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? <FiChevronLeft /> : <FiChevronRight />}
        </div>
      </div>

      {/* Dashboard List */}
      <ul className="dashboard-list">
        {dashboards.map((name) => {
          const isDisabled = name === "Order Book";

          return (
            <li
              key={name}
              className={`dashboard-item ${activeDashboard === name ? "active" : ""
                } ${isDisabled ? "disabled-dashboard" : ""}`}
              onClick={() => !isDisabled && setActiveDashboard(name)}
            >
              <span className="item-content">
                {/* <FiGrid className="item-icon" /> */}
                {isExpanded && <span className="label">{name}</span>}
              </span>

              {activeDashboard === name && <span className="active-indicator" />}
            </li>
          );
        })}
      </ul>

      {/* History */}
      {isExpanded && (
        <div className="history">
          <div className="history-text">
            <FiClock size={16} />
            <span>History</span>
          </div>

          <div className="history-header">Recent queries</div>

          {recentQueries.length === 0 ? (
            <div className="history-item empty">No recent queries</div>
          ) : (
            recentQueries.map((query, idx) => (
              <div
                key={idx}
                className="history-item"
                onClick={() => onQuerySelect(query)}
              >
                {query}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default Sidebar;
